import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { VisibilityOffIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { UC_SERVICES } from 'consent/usercentricsConfig';
import { useUsercentricsActions } from 'consent/useUsercentricsActions';
import { ReactElement } from 'react';

const YOUTUBE_CONSENT_MESSAGE =
  'Bitte passe deine Cookie-Einstellungen an (YouTube Video), um dir alle Videos auf Novaheal ansehen zu können.';

const YOUTUBE_CONSENT_BUTTON_LABEL = 'Cookies anpassen';

type Props = {
  title: string;
};

export const YouTubeConsentPlaceholder = ({ title }: Props): ReactElement => {
  const { openConsentSettings } = useUsercentricsActions();

  const handleOpenSettings = async (): Promise<void> => {
    await openConsentSettings(UC_SERVICES.youtube);
  };

  return (
    <Box
      position="absolute"
      inset={0}
      width="100%"
      height="100%"
      bg="background.canvas"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px="5xl"
      py={{ base: 'xl', md: '76px' }}
      aria-label={`${title}. ${YOUTUBE_CONSENT_MESSAGE}`}
    >
      <VStack gap="m" maxW="100%" align="center">
        <NovaIcon icon={VisibilityOffIcon} size="l" color="icon.tertiary" aria-hidden />
        <Text textStyle="body.s.regular" color="text.primary" textAlign="center">
          {YOUTUBE_CONSENT_MESSAGE}
        </Text>
        <Button
          variant="secondaryOutline"
          borderColor="border.accent"
          color="text.primary"
          textStyle="body.s.regular"
          borderRadius="l"
          px="m"
          py="s"
          onClick={handleOpenSettings}
        >
          {YOUTUBE_CONSENT_BUTTON_LABEL}
        </Button>
      </VStack>
    </Box>
  );
};
